import React from 'react';
import Game from './Game.js'
import HowToPlayModal from './HowToPlayModal.js';
import { setSoundsEnabled } from './audio/sounds';

import './App.css';

class App extends React.Component {

  constructor(props) {
    super(props);
    this.state = { theme: 'light', showRules: false, showSettings: false, allowAugRound1: false, muted: false };
    this.gameRef = null;
  }

  componentDidMount() {
    // Load persisted settings
    try {
      const k = 'gc_allow_aug_round1';
      const raw = window.localStorage.getItem(k);
      if (raw != null) {
        const val = raw === '1' || raw === 'true';
        this.setState({ allowAugRound1: val });
      }
    } catch (_) {}
    // Load muted setting
    try {
      const mutedRaw = window.localStorage.getItem('gc_muted');
      if (mutedRaw != null) {
        const muted = mutedRaw === '1' || mutedRaw === 'true';
        this.setState({ muted });
        setSoundsEnabled(!muted);
      }
    } catch (_) {}
  }

  toggleMute = () => {
    const next = !this.state.muted;
    this.setState({ muted: next });
    setSoundsEnabled(!next);
    try { window.localStorage.setItem('gc_muted', next ? '1' : '0'); } catch (_) {}
  }

  render() {
    const isDark = this.state.theme === 'dark';
    const rootStyle = isDark
      ? { background: '#121212', color: '#f1f1f1', minHeight: '100vh' }
      : { background: '#ffffff', color: '#111111', minHeight: '100vh' };
    return (
        <>
          <div style={rootStyle}>
            <style>{`
              body { font-family: ui-sans-serif, system-ui, -apple-system, Segoe UI, Roboto, Helvetica, Arial, Noto Sans, "Apple Color Emoji", "Segoe UI Emoji"; }
              .gc-switch { position: relative; display: inline-block; width: 32px; height: 18px; }
              .gc-switch input { opacity: 0; width: 0; height: 0; }
              .gc-slider { position: absolute; cursor: pointer; top: 0; left: 0; right: 0; bottom: 0; background: #cfcfcf; transition: .2s; border-radius: 18px; }
              .gc-slider:before { position: absolute; content: ""; height: 14px; width: 14px; left: 2px; top: 2px; background: #fff; transition: .2s; border-radius: 50%; box-shadow: 0 1px 2px rgba(0,0,0,0.3); }
              .gc-switch input:checked + .gc-slider { background: #4caf50; }
              .gc-switch input:checked + .gc-slider:before { transform: translateX(14px); }
            `}</style>
            <div style={{ width: 560, margin: '0 auto', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <div style={{ fontWeight: 800 }}>GrottoChess</div>
              </div>
              <nav style={{ display: 'flex', alignItems: 'center' }}>
                <a
                  href="#"
                  onClick={(e) => { e.preventDefault(); this.setState({ showRules: true }); }}
                  style={{ textDecoration: 'underline', color: 'inherit', marginRight: 4 }}
                  title="How to play"
                >How to play</a>
                <button
                  onClick={this.toggleMute}
                  title={this.state.muted ? 'Unmute sounds' : 'Mute sounds'}
                  style={{ border: 'none', background: 'transparent', cursor: 'pointer', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', width: 28, height: 28, color: '#888' }}
                  aria-label={this.state.muted ? 'Unmute sounds' : 'Mute sounds'}
                >
                  {this.state.muted ? (
                    <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5"></polygon>
                      <line x1="23" y1="9" x2="17" y2="15"></line>
                      <line x1="17" y1="9" x2="23" y2="15"></line>
                    </svg>
                  ) : (
                    <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5"></polygon>
                      <path d="M19.07 4.93a10 10 0 0 1 0 14.14"></path>
                      <path d="M15.54 8.46a5 5 0 0 1 0 7.07"></path>
                    </svg>
                  )}
                </button>
                <button
                  onClick={() => this.setState({ showSettings: true })}
                  title="Settings"
                  style={{ border: 'none', background: 'transparent', cursor: 'pointer', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', width: 28, height: 28, color: '#888' }}
                  aria-label="Open settings"
                >
                  <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <circle cx="12" cy="12" r="3"></circle>
                    <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 1 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 1 1-4 0v-.09a1.65 1.65 0 0 0-1-1.51 1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 1 1-2.83-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 1 1 0-4h.09a1.65 1.65 0 0 0 1.51-1 1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 1 1 2.83-2.83l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 1 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 1 1 2.83 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9c0 .66.26 1.3.73 1.77.47.47 1.11.73 1.77.73H21a2 2 0 1 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z"></path>
                  </svg>
                </button>
              </nav>
            </div>
            <Game theme={this.state.theme} allowAugRound1={this.state.allowAugRound1} ref={(el) => { this.gameRef = el; }} />
            {this.state.showRules ? (
              <HowToPlayModal theme={this.state.theme} onClose={() => this.setState({ showRules: false })} />
            ) : null}
            {this.state.showSettings ? (
              <div role="dialog" aria-modal="true" aria-label="Settings" style={{ position: 'fixed', inset: 0, zIndex: 10000 }}>
                <div onClick={() => this.setState({ showSettings: false })} style={{ position: 'absolute', inset: 0, background: 'rgba(0,0,0,0.6)' }}></div>
                <div style={{ position: 'relative', maxWidth: 480, margin: '64px auto', background: isDark ? '#1e1e1e' : '#ffffff', color: isDark ? '#f1f1f1' : '#111111', borderRadius: 10, boxShadow: '0 10px 30px rgba(0,0,0,0.35)' }}>
                  <div style={{ padding: '16px 20px', borderBottom: `1px solid ${isDark ? '#333' : '#eee'}`, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                    <div style={{ fontSize: 18, fontWeight: 800 }}>Settings</div>
                    <button onClick={() => this.setState({ showSettings: false })} style={{ border: 'none', background: 'transparent', color: isDark ? '#cfcfcf' : '#555555', cursor: 'pointer', fontSize: 22, lineHeight: 1 }} aria-label="Close settings">×</button>
                  </div>
                  <div style={{ padding: '16px 20px', display: 'grid', gridTemplateColumns: '1fr', gap: 16 }}>
                    <section>
                      <div style={{ fontWeight: 700, marginBottom: 8 }}>Game</div>
                      <button onClick={() => { try { this.gameRef?.confirmNewGame?.(); } catch (_) {}; this.setState({ showSettings: false }); }} style={{ padding: '8px 12px', cursor: 'pointer' }}>Restart Game</button>
                    </section>
                    <section>
                      <div style={{ fontWeight: 700, marginBottom: 8 }}>Augments</div>
                      <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                        <span style={{ minWidth: 180 }}>Allow augments in round 1</span>
                        <label className="gc-switch" title="Allow augments in round 1">
                          <input
                            type="checkbox"
                            checked={!!this.state.allowAugRound1}
                            onChange={() => {
                              const next = !this.state.allowAugRound1;
                              this.setState({ allowAugRound1: next });
                              try { window.localStorage.setItem('gc_allow_aug_round1', next ? '1' : '0'); } catch (_) {}
                            }}
                          />
                          <span className="gc-slider"></span>
                        </label>
                      </div>
                    </section>
                    <section>
                      <div style={{ fontWeight: 700, marginBottom: 8 }}>Appearance</div>
                      <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                        <span style={{ minWidth: 80 }}>Dark mode</span>
                        <label className="gc-switch" title="Dark mode">
                          <input type="checkbox" checked={isDark} onChange={() => this.setState({ theme: isDark ? 'light' : 'dark' })} />
                          <span className="gc-slider"></span>
                        </label>
                      </div>
                    </section>
                  </div>
                </div>
              </div>
            ) : null}
          </div>
        </>
      );
  }
}


export default App;
